import { useEffect } from 'react';
import CopyIcon from '../../../../assets/Modals/CopyIcon';
import DeleteIcon from '../../../../assets/Modals/DeleteIcon';
import Denounce from '../../../../assets/Modals/Denounce';
import SelectMessageIcon from '../../../../assets/Modals/SelectMessageIcon';
import ShareIcon from '../../../../assets/Posts/ShareIcon';
import { Button, Container } from './styles';

type MessageModalProps = {
  open: boolean;
  authorUsername: string;
  onAction: any;
  sent: boolean;
  scrollPosition: number;
  scrollHeight: number;
  positionRect: any;
  setModal: (state: boolean) => void;
};

export default function MessageModal({
  open,
  authorUsername,
  onAction,
  sent,
  scrollPosition,
  scrollHeight,
  positionRect,
  setModal,
}: MessageModalProps) {
  // console.log('positionRect.top', positionRect.top);
  // console.log('scrollHeight', scrollHeight);
  // console.log('scrollPosition', scrollPosition);
  const marginTop = sent ? -scrollPosition * 2 + 230 : -scrollPosition * 2 + 270;
  const marginRight = sent ? positionRect.width / 2 - 20 : positionRect.width - 120;
  const marginLeft = sent ? 0 : 0;

  const isCloseToBottom = scrollPosition + scrollHeight - positionRect.top < 650;
  console.log('scrollPosition + scrollHeight - positionRect.top', scrollPosition + scrollHeight - positionRect.top);
  console.log('isCloseToBottom', isCloseToBottom);
  useEffect(() => {
    if (scrollPosition + scrollHeight - positionRect.top < 150) {
      console.log('close');
      setModal(false);
    }
  }, [scrollPosition, scrollHeight, positionRect.top, setModal]);

  return (
    <>
      {open && (
        <Container
          style={{
            marginTop: isCloseToBottom ? marginTop - 500 : marginTop,
            marginRight: marginRight,
            marginLeft: marginLeft,
            // marginBottom: positionRect.top
          }}>
          <Button delete={false}>
            <ShareIcon />
            Compartilhar
          </Button>
          <Button delete={false} onClick={() => onAction('select')}>
            <SelectMessageIcon />
            Selecionar mensagem
          </Button>
          <Button delete={false}>
            <CopyIcon />
            Copiar mensagem
          </Button>
          <Button delete={true} onClick={() => onAction('delete')}>
            <DeleteIcon />
            Excluir mensagem
          </Button>
          {!sent && (
            <Button delete={true}>
              <Denounce />
              Denunciar
            </Button>
          )}
        </Container>
      )}
    </>
  );
}